import React from "react";
import { Box, Button, Flex, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { FiArrowUpRight, FiClipboard } from "react-icons/fi";

const truncate = (text, max = 140) => {
  if (!text) return "";
  const str = String(text).trim();
  if (str.length <= max) return str;
  return str.slice(0, max).replace(/\s+\S*$/, "") + "…";
};

export const NoticeBoardCard = ({
  cardBg,
  cardText,
  cardTitle,
  cardMuted,
  t,
  notices = [],
  onAddNotice,
}) => {
  const headingLabel =
    t("dashboard.notice_board_title") ||
    t("card_view.tab_notice_board") ||
    t("right_rail.notice_board.title");
  const list = Array.isArray(notices) ? notices.slice(0, 3) : [];

  return (
    <Box
      bg={cardBg}
      color={cardText}
      borderRadius="md"
      overflow="hidden"
      boxShadow="md"
      p={4}
    >
      <HStack mb={2} spacing={2} justify="space-between" align="center">
        <HStack spacing={2} align="center">
          <Icon as={FiClipboard} />
          <Text textStyle="cardTitle" color={cardTitle}>
            {headingLabel}
          </Text>
        </HStack>
      </HStack>
      <Text fontSize="xs" color={cardMuted} mb={3}>
        {t("right_rail.notice_board.subtitle")}
      </Text>
      {list.length === 0 ? (
        <Text fontSize="sm" color={cardMuted}>
          {t("right_rail.no_suggestions")}
        </Text>
      ) : (
        <VStack align="stretch" spacing={3}>
          {list.map((notice) => (
            <Box
              key={notice.notice_id || notice.id}
              as={RouterLink}
              to="/noticeboard"
              bg="blackAlpha.200"
              borderRadius="md"
              p={3}
              borderWidth="1px"
              borderColor="whiteAlpha.200"
              cursor="pointer"
              _hover={{ bg: "blackAlpha.300", borderColor: "whiteAlpha.400", textDecoration: "none" }}
              transition="all 0.15s ease"
            >
              <Text fontSize="sm" fontWeight="semibold" color={cardTitle}>
                {notice.title || t("top_menu.untitled")}
              </Text>
              <Text fontSize="xs" color={cardText} mt={1}>
                {truncate(notice.description || notice.content || "")}
              </Text>
            </Box>
          ))}
        </VStack>
      )}
      {/* Wrap, never squeeze. In English the two labels fit one line; in
          French ("Aller au tableau" / "Publier une annonce") they do not, and
          an HStack compressed the buttons until their text rendered outside
          the borders and overlapped. flexShrink={0} keeps each button at its
          label's width so the row breaks onto a second line instead. */}
      <Flex mt={4} gap={2} wrap="wrap" justify="flex-end">
        <Button
          size="sm"
          colorScheme="gwbi"
          variant="outline"
          rightIcon={<FiArrowUpRight />}
          as={RouterLink}
          to="/noticeboard"
          flexShrink={0}
        >
          {t("right_rail.notice_board.cta")}
        </Button>
        {onAddNotice ? (
          <Button
            size="sm"
            colorScheme="gwbi"
            onClick={onAddNotice}
            flexShrink={0}
          >
            {t("right_rail.notice_board.add")}
          </Button>
        ) : null}
      </Flex>
    </Box>
  );
};

export default NoticeBoardCard;
